<div class="dialog-form">
	@let medDict = svcDataFactory.svcDataMeds.getMedById(this.rec().medication);
	<app-input-wrapper class="flex-none" label="Medication">
		<select [(ngModel)]="rec().medication" [classList]="'custom-input'">
			@for (med of (svcDataFactory.svcDataMeds.medsList | async); track med.id) {
				@let m = svcDataFactory.svcDataMeds.getMedById(med.id);
				@if (m) {
					<option [value]="m.id">{{ (m.medication) }}</option>
				}
			}
		</select>
	</app-input-wrapper>

	<app-input-wrapper class="flex-none" label="Dosage" [units]="rec().unit">
		<input [(ngModel)]="rec().dosage" type="number" id="dose" name="dose"/>
	</app-input-wrapper>

</div>